var ValueJS = ValueJS || {};

ValueJS.InfiniteScroll = function() {

    var _selector = {
        'container': '.infinite-scroll',
        'append': '.infinite-scroll__item',
        'pagination': '.infinite-scroll__pagination',
        'path': '.infinite-scroll__next',
        'status': '.page-load-status'
    };
    var _scroller = {};
    var _initialized = false;

    var _init = function() {
        if (!_initialized) {
            _scroller = $(_selector.container);
            if ($(_selector.path).length) {
                _scroller.infiniteScroll({
                    path: _selector.path,
                    append: _selector.append,
                    hideNav: _selector.pagination,
                    status: _selector.status
                });
                _scroller.on('append.infiniteScroll', function() {
                    if (!$(_selector.path).length) {
                        _scroller.infiniteScroll('destroy');
                        _initialized = false;
                    }
                    ValueJS.AnimateCSS.domUpdate();
                    ValueJS.BootstrapTooltips.domUpdate();
                    ValueJS.LazyLoad.domUpdate();
                    ValueJS.ProductCard.domUpdate();
                    ValueJS.Wishlist.domUpdate();
                });
            }
            _initialized = true;
        }
    }

    var _domUpdate = function() {
        _scroller.infiniteScroll('destroy');
        _scroller = {};
        _initialized = false;
        _init();
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
        domUpdate : function() {return _domUpdate();}
    };

}();

$(function() {
    // ValueJS.InfiniteScroll.init();
});
